<div class="chart-settings-title">{{ 'settings' | translate }}</div>

<div class="table" [formGroup]="settingsForm">
	<div>
		<div class="cell">
			<mat-form-field appearance="outline" class="graph-settings-field">
				<mat-label>{{ 'lower' | translate }}</mat-label>
				<input type="number" formControlName="lowerBound" matInput />
				@if (settingsForm.get('lowerBound')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="cell">
			<mat-form-field appearance="outline" class="graph-settings-field">
				<mat-label>{{ 'upper' | translate }}</mat-label>
				<input type="number" formControlName="upperBound" matInput />
				@if (settingsForm.get('upperBound')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="cell">
			<mat-form-field appearance="outline" class="graph-settings-field">
				<mat-label>{{ 'target' | translate }}</mat-label>
				<input type="number" formControlName="benchmark" matInput />
				@if (settingsForm.get('benchmark')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="cell">
			<mat-form-field appearance="outline" class="graph-settings-field">
				<mat-label>{{ 'unit' | translate }}</mat-label>
				<input type="text" formControlName="unit" matInput />
				@if (settingsForm.get('unit')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
	<div>
		<div class="cell">
			<mat-form-field appearance="outline" class="graph-settings-field">
				<mat-label>{{ 'description' | translate }}</mat-label>
				<input type="text" formControlName="description" matInput />
				@if (settingsForm.get('description')?.invalid) {
					<mat-error>{{ 'please_enter_valid_value' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
</div>
